import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  Stack,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AktivuDropzone from '../components/shared/AktivuDropzone';
import { MEDIUM_DIALOG } from '../utils/constants';

// dialog transition
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * UploadDialog is a full screen layout
 * @param {*} props
 * @returns
 */
const UploadDialog = props => {
  const {
    upload_type,
    prefix,
    title,
    processData = false,
    processForm = () => {},
    uploadDialog = false,
    setUploadDialog,
  } = props;

  const theme = useTheme();

  const closeUploadDialog = () => {
    setUploadDialog(false);
  };

  /**
   * TODO: wire form data if required
   * Future Use. For processing FormData with the uploads
   */
  const processFormDataAndClose = () => {
    processForm();
    closeUploadDialog();
  };

  /**
   * 🤯 Hack Alert: to prevent type error on a dialog click when there is a grid in the dialog
   * @param {*} e
   */
  const handleDialogClick = e => {
    e.stopPropagation();
  };

  return (
    <Dialog
      open={uploadDialog}
      TransitionComponent={Transition}
      onClose={closeUploadDialog}
      onClick={handleDialogClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...MEDIUM_DIALOG}
    >
      <DialogContent>
        <Stack spacing={2}>
          <AktivuDropzone
            title={title || 'Upload Files'}
            showTitle={true}
            upload_type={upload_type || 'generic'}
            prefix={prefix || `generic-${Date.now()}`}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={closeUploadDialog}
          variant="contained"
          style={{ backgroundColor: theme.palette.error.main }}
        >
          Close
        </Button>
        {processData && (
          <Button
            onClick={processFormDataAndClose}
            autoFocus
            variant="contained"
            style={{ backgroundColor: theme.palette.secondary.main }}
          >
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default UploadDialog;
